import { createBrowserRouter } from 'react-router-dom';

// routes
// import MainRoutes from './MainRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';

// project import
import { BritamISCRoutes } from './ISCRoutes';
import { BritamCSEBDRoutes } from './CSE&BBRoutes';
import { BritamUnderWriterRoutes } from './UnderWriterRoutes';
import { BritamAdminRoutes } from './BritamAdminRoutes';
import { AgencyAdminRoutes } from './AgencyAdminRoutes';
import WebsiteRoutes from './NormalUserRoutes';
import { NotFoundPage } from 'Application/pages/shared/NotFoundPage';
import { VerifyDocumentPage } from 'Application/pages/shared';

// ==============================|| ROUTING RENDER ||============================== //
const router = createBrowserRouter(
    [
        AuthenticationRoutes,
        AgencyAdminRoutes,
        BritamAdminRoutes,
        BritamUnderWriterRoutes,
        BritamISCRoutes,
        BritamCSEBDRoutes,
        WebsiteRoutes,
        {
            path: '/verify/document',
            element: <VerifyDocumentPage />
        },
        {
            path: '*',
            element: <NotFoundPage />
        },
    ],
    {
        basename: import.meta.env.VITE_APP_BASE_NAME
    }
);

export default router;
